import { when } from 'mobx';
export default function LaunchCircularViewF(pluginManager) {
    pluginManager.addToExtensionPoint('LaunchView-CircularView', 
    // @ts-expect-error
    async ({ session, assembly, tracks = [], }) => {
        const { assemblyManager } = session;
        const view = session.addView('CircularView', {});
        await when(() => view.initialized);
        if (!assembly) {
            throw new Error('No assembly provided when launching circular genome view');
        }
        const asm = await assemblyManager.waitForAssembly(assembly);
        if (!asm) {
            throw new Error(`Assembly "${assembly}" not found when launching circular genome view`);
        }
        view.setDisplayedRegions(asm.regions || []);
        tracks.forEach(track => view.showTrack(track));
    });
}
